var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

import React, { Component } from 'react';
import { Button, Tooltip, TabCard, shapes, Dropdown as CustomDropdown, Icon, Snackbar } from '@cimpress/react-components';
import Dropdown from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import 'react-dropdown/style.css';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import * as colors from '@cimpress/react-components/lib/colors';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid/dist/styles/ag-grid.css';
import 'ag-grid/dist/styles/ag-theme-balham.css';
import PriceCellRenderer from '../PriceCellRenderer';
import CustomLoadingOverlay from '../CustomLoadingOverlay';
import { capitalize, colorStyle, disableGridCell, getErrorMessageAndColor, getFiscalYear, getGridSettingsUser, setGridSettingsUser, getKeyFromTabIndex } from '../../utils/utils';
import { changeRowDataByPriceMode, createBudgetRateMap, getDropdownOptionsForSku, getGridCellMaxLength, getLowestLevelHeaders, getPinnedWidth, updatePriceByBudgetRate, getCurrencyOptions } from '../../utils/PricingGridLayoutUtils';
import Export from '../export/Export';
import ConfigShippingContainer from '../ShippingConfiguration';
import { convertFulfillmentLocationToOptions, getDeliveryLocationOptions } from '../ShippingConfiguration/shippingConfigUtil';
import PricingChart from '../charts/PricingChart';
import { ingestData } from '../../services/cimbaIngestion';
import GrossMarginLayout from './GrossMarginLayout';
var tooltipStyle = {
  maxWidth: '350px'
};
var customStyles = {
  control: function control(base, state) {
    return __assign(__assign({}, base), {
      borderWidth: state.isFocused ? '0.3px' : '1px',
      borderColor: state.isFocused ? '#41b5dc' : '#c4cdd6',
      boxShadow: state.isFocused ? '0 0 0 1px #41b5dc' : null
    });
  },
  menu: function menu(provided) {
    return __assign(__assign({}, provided), {
      height: '135px',
      overflow: 'auto'
    });
  },
  menuList: function menuList(provided) {
    return __assign(__assign({}, provided), {
      maxHeight: '135px',
      overflow: 'auto'
    });
  }
};
var styles = {
  headerList: {
    padding: 0
  },
  subHeaderList: {
    padding: 0
  },
  listItemText: {
    fontSize: '12px',
    fontFamily: 'inherit'
  },
  outerListItem: {
    paddingTop: 0,
    paddingBottom: 0,
    paddingRight: 0
  },
  nestedListItem: {
    paddingLeft: 0
  }
};
var Robot = shapes.Robot,
    Spinner = shapes.Spinner; // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore

var PricingGridLayoutV2 =
/** @class */
function (_super) {
  __extends(PricingGridLayoutV2, _super);

  function PricingGridLayoutV2(props) {
    var _this = _super.call(this, props) || this;

    _this.WIDTH = 117;

    _this.getInitialState = function () {
      return {
        initialize: true,
        columnArray: [],
        pinnedWidth: undefined,
        shippingClicked: true,
        showPopover: {
          settings: false,
          navigation: false,
          filter: false
        },
        fiscalYear: getFiscalYear(),
        rowData: null,
        headers: _this.props.results ? _this.props.results.headers : null,
        priceMode: _this.props.priceMode,
        currencyOptions: getCurrencyOptions(),
        currency: undefined,
        showShippingModal: false,
        showCurrencySnackbar: null,
        budgetRatesMap: [],
        selectedIndex: _this.props.selectedTab || 0,
        headerPrice: [],
        headerCost: [],
        grossMarginHeader: {},
        grossMarginSelections: _this.props.grossMarginSelections || {
          cost: undefined,
          price: undefined
        },
        showGrossMarginChart: false
      };
    };

    _this.componentDidCatch = function (error, info) {
      if (_this.props.logger) {
        _this.props.logger.logError({
          message: 'Error occurred in PricingGridLayout Error Boundary',
          error: {
            errorInfo: error,
            info: info
          }
        }, 'pricingGrid');
      }
    };

    _this.getLowest = function (skuHeader, array) {
      if (!skuHeader.isParent) {
        array.push(skuHeader);
      } else {
        skuHeader.children.forEach(function (head) {
          _this.getLowest(head, array);
        });
      }
    };

    _this.createSkuDropdown = function (headers) {
      if (headers && headers.headerList) {
        var skuHeader = headers.headerList[0];
        var options = getDropdownOptionsForSku(skuHeader.children, false).flat();
        var skuDropdown = {
          options: options,
          selected: options[0]
        };

        _this.setState({
          skuDropdown: skuDropdown
        });
      }
    };

    _this.componentDidMount = function () {
      _this.setDefaultSettings();

      if (_this.props.results && _this.props.results.headers) {
        if (_this.props.showCompetitivePricing) {
          _this.createSkuDropdown(_this.props.results.headers);
        }
      }

      if (_this.state.headers) {
        var grossMarginSelections = void 0;
        var showLoadingSpinnerEquivalency = _this.props.isLoadingEquivalencies;

        var _a = _this.getHeadersForTabs(cloneDeep(_this.state.headers)),
            headerPrice = _a.headerPrice,
            headerCost = _a.headerCost,
            grossMarginHeader = _a.grossMarginHeader;

        if (_this.props.grossMarginSelections) {
          // eslint-disable-next-line prefer-destructuring
          grossMarginSelections = _this.props.grossMarginSelections;
        }

        _this.setState({
          headerPrice: headerPrice,
          headerCost: headerCost,
          grossMarginHeader: grossMarginHeader,
          grossMarginSelections: grossMarginSelections,
          columnArray: _this.getColumnDefinitions(),
          showLoadingSpinnerEquivalency: showLoadingSpinnerEquivalency
        }, function () {
          _this.setRowData();
        });
      }
    };

    _this.setDefaultSettings = function () {
      return getGridSettingsUser().then(function (gridSettings) {
        if (gridSettings) {
          var priceMode = gridSettings.priceMode,
              currency_1 = gridSettings.currency;
          var newCurrency = void 0;

          if (currency_1) {
            newCurrency = _this.state.currencyOptions.find(function (obj) {
              return obj.value === currency_1;
            });
          }

          _this.setState({
            priceMode: priceMode || 'total',
            currency: newCurrency
          });
        }
      });
    };

    _this.addShowToHeaders = function (headerList) {
      return headerList.map(function (header) {
        header.show = true;

        if (header.children) {
          header.children = _this.addShowToHeaders(header.children);
        }

        return header;
      });
    };

    _this.createPivotChildren = function () {
      var results = _this.props.results;

      if (results) {
        var headers = results.headers;

        if (headers) {
          var pivotHeaders = getLowestLevelHeaders(headers.headerList && headers.headerList[0]);

          _this.setState({
            pivotHeaders: pivotHeaders
          });
        }
      }
    };

    _this.onDropDownSelection = function (selected) {
      var skuDropdown = _this.state.skuDropdown;

      _this.setState({
        skuDropdown: __assign(__assign({}, skuDropdown), {
          selected: selected
        })
      });
    };

    _this.createHeadersList = function (headerList, headerLevel) {
      var skuDropdown = _this.state.skuDropdown;
      return headerList.map(function (header) {
        var headerClass = headerLevel % 2 === 0 ? 'even-header' : '';

        if (header.isParent) {
          var childCells = [];

          if (_this.props.showCompetitivePricing && header.name !== 'Competitors') {
            childCells.push({
              field: skuDropdown && skuDropdown.selected ? skuDropdown.selected.value : undefined,
              type: 'numericColumn',
              minWidth: 220,
              filter: 'agTextColumnFilter',
              cellRendererFramework: PriceCellRenderer,
              cellStyle: function cellStyle(params) {
                if (disableGridCell(params.value)) return {
                  background: '#E6E6E6'
                };
                return undefined;
              },
              headerComponentFramework: function headerComponentFramework() {
                return React.createElement("div", {
                  className: "merchant-style",
                  style: {
                    height: '45px',
                    borderRight: '1px solid #bdc3c7'
                  }
                }, React.createElement(CustomDropdown, {
                  title: skuDropdown.selected.label,
                  className: "merchant-selector competitive-merchant-selector"
                }, skuDropdown.options.map(function (option) {
                  return (// eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                    React.createElement("a", {
                      key: option.label,
                      onClick: function onClick() {
                        return _this.onDropDownSelection(option);
                      }
                    }, option.label)
                  );
                })));
              }
            });
          } else {
            childCells = _this.createHeadersList(header.children, headerLevel + 1);
          }

          return {
            headerName: capitalize(header.name),
            children: childCells,
            minWidth: 150,
            resizable: true,
            headerClass: headerClass
          };
        }

        var cell = {
          headerName: capitalize(header.name),
          field: "" + header.value,
          filter: false,
          cellRendererFramework: PriceCellRenderer,
          type: 'numericColumn',
          resizable: true,
          minWidth: 157,
          headerComponentFramework: function headerComponentFramework(params) {
            var _a = __read(getErrorMessageAndColor(header), 2),
                message = _a[0],
                color = _a[1];

            if (message && color) {
              return React.createElement(Tooltip, {
                direction: "top",
                contents: message,
                className: "honor-newlines",
                containerClassName: "span-grid-style"
              }, React.createElement("div", {
                className: "custom-select " + (!_this.props.isPivoting ? 'error-style' : null)
              }, React.createElement(Icon, {
                color: colorStyle[color],
                style: {
                  pointerEvents: 'none'
                },
                name: "report-problem-triangle-f"
              }), React.createElement("span", null, params.displayName)));
            }

            if (header.info) {
              var _b = header.info,
                  priceModelId = _b.priceModelId,
                  revisionId = _b.revisionId,
                  contractId = _b.contractId,
                  contractRevisionId = _b.contractRevisionId,
                  effectiveStartDate = _b.effectiveStartDate;
              var priceModelLink = "https://pricingmanager.financialflows.cimpress.io/models/" + priceModelId + "?revision=" + revisionId;
              var contractLink = "https://contractmanager.ff.cimpress.io/" + contractId + "/" + contractRevisionId;
              return React.createElement("div", {
                className: "span-grid-style",
                style: {
                  width: '100%',
                  alignSelf: 'center'
                }
              }, params.displayName, ' ', React.createElement(Tooltip, {
                direction: "bottom",
                variety: "popover",
                tooltipStyle: {
                  maxWidth: '400px'
                },
                contents: React.createElement("div", null, React.createElement("div", {
                  style: {
                    marginBottom: '10px'
                  }
                }, React.createElement("div", {
                  style: {
                    fontSize: '10px',
                    fontWeight: 'bold',
                    marginBottom: '10px'
                  }
                }, "PRICING"), React.createElement("div", {
                  style: {
                    fontSize: '12px',
                    marginBottom: '5px',
                    display: 'flex',
                    justifyContent: 'space-between'
                  }
                }, React.createElement("div", {
                  style: {
                    color: '#6f7d88',
                    marginRight: '20px'
                  }
                }, "Price Configuration"), React.createElement("div", null, React.createElement("a", {
                  href: priceModelLink,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  className: "header-detail-link"
                }, priceModelId))), React.createElement("div", {
                  style: {
                    fontSize: '12px',
                    marginBottom: '5px',
                    display: 'flex',
                    justifyContent: 'space-between'
                  }
                }, React.createElement("div", {
                  style: {
                    marginRight: '20px',
                    color: '#6f7d88'
                  }
                }, "Revision ID"), React.createElement("div", null, revisionId))), contractId ? React.createElement("div", null, React.createElement("div", {
                  style: {
                    fontSize: '10px',
                    fontWeight: 'bold',
                    marginBottom: '10px'
                  }
                }, "CONTRACT"), React.createElement("div", {
                  style: {
                    fontSize: '12px',
                    marginBottom: '5px',
                    display: 'flex',
                    justifyContent: 'space-between'
                  }
                }, React.createElement("div", {
                  style: {
                    marginRight: '20px',
                    color: '#6f7d88'
                  }
                }, "Contract"), React.createElement("div", null, React.createElement("a", {
                  href: contractLink,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  className: "header-detail-link"
                }, contractId))), React.createElement("div", {
                  style: {
                    fontSize: '12px',
                    marginBottom: '5px',
                    display: 'flex',
                    justifyContent: 'space-between'
                  }
                }, React.createElement("div", {
                  style: {
                    marginRight: '20px',
                    color: '#6f7d88'
                  }
                }, "Revision ID"), React.createElement("div", null, contractRevisionId)), React.createElement("div", {
                  style: {
                    fontSize: '12px',
                    marginBottom: '5px',
                    display: 'flex',
                    justifyContent: 'space-between'
                  }
                }, React.createElement("div", {
                  style: {
                    marginRight: '20px',
                    color: '#6f7d88'
                  }
                }, "Effective Start Date"), React.createElement("div", null, effectiveStartDate))) : null),
                className: "honor-newlines"
              }, React.createElement(Icon, {
                style: {
                  marginLeft: '4px',
                  marginTop: '1px'
                },
                color: "#0088a8",
                name: "infomation-circle-f",
                size: "lg"
              })));
            }

            return React.createElement("span", {
              className: "span-grid-style"
            }, params.displayName);
          },
          cellStyle: function cellStyle(params) {
            if (disableGridCell(params.value)) return {
              background: '#E6E6E6'
            };
            return null;
          },
          headerClass: headerClass
        };
        return cell;
      });
    };

    _this.getColumnDefinitionsV2 = function (headers) {
      var columnDefinitions = [];

      if (headers) {
        if (headers.pinned) {
          var results = _this.props.results;
          var pinnedHeader = headers.pinned;
          var pinnedWidth = results && results.rowData ? getPinnedWidth(results.rowData, pinnedHeader.name) : 150;
          var cellPinned = {
            headerName: capitalize(pinnedHeader.name),
            field: capitalize(pinnedHeader.value),
            filter: 'agTextColumnFilter',
            cellRendererFramework: PriceCellRenderer,
            pinned: 'left',
            lockPinned: true,
            cellClass: 'pinnedCellStyle',
            sortable: true,
            unSortIcon: true,
            rowDrag: true,
            lockPosition: true,
            suppressSizeToFit: true,
            tooltipField: 'quantity',
            headerClass: 'header-class-test',
            width: pinnedWidth,
            minWidth: pinnedWidth
          };
          columnDefinitions.push(cellPinned);
        }

        if (headers.headerList && Array.isArray(headers.headerList)) {
          var maxLength = getGridCellMaxLength(headers.headerList); // eslint-disable-next-line no-nested-ternary

          var headerHeight = _this.props.showCompetitivePricing ? 45 : maxLength < 23 ? 45 : Math.ceil(maxLength / 23) * 8 + 50;

          if (_this.costGridApi) {
            _this.costGridApi.setHeaderHeight(headerHeight);
          }

          if (_this.priceGridApi) {
            _this.priceGridApi.setHeaderHeight(headerHeight);
          }

          var headerList = _this.createHeadersList(headers.headerList, 1);

          columnDefinitions.push.apply(columnDefinitions, __spread(headerList));
        }
      }

      return columnDefinitions;
    };

    _this.getColumnDefinitions = function () {
      var headers = _this.state.headers;
      var columnDefinitions = [];

      if (headers) {
        if (headers.pinned) {
          var results = _this.props.results;
          var pinnedHeader = headers.pinned;
          var pinnedWidth = results && results.rowData ? getPinnedWidth(results.rowData, pinnedHeader.name) : 150;
          var cellPinned = {
            headerName: capitalize(pinnedHeader.name),
            field: capitalize(pinnedHeader.value),
            filter: 'agTextColumnFilter',
            cellRendererFramework: PriceCellRenderer,
            pinned: 'left',
            lockPinned: true,
            cellClass: 'pinnedCellStyle',
            sortable: true,
            unSortIcon: true,
            rowDrag: true,
            lockPosition: true,
            suppressSizeToFit: true,
            tooltipField: 'quantity',
            headerClass: 'header-class-test',
            width: pinnedWidth,
            minWidth: pinnedWidth
          };
          columnDefinitions.push(cellPinned);
        }

        if (headers.headerList && Array.isArray(headers.headerList)) {
          var maxLength = getGridCellMaxLength(headers.headerList); // eslint-disable-next-line no-nested-ternary

          var headerHeight = _this.props.showCompetitivePricing ? 45 : maxLength < 23 ? 45 : Math.ceil(maxLength / 23) * 8 + 50;

          if (_this.costGridApi) {
            _this.costGridApi.setHeaderHeight(headerHeight);
          }

          if (_this.priceGridApi) {
            _this.priceGridApi.setHeaderHeight(headerHeight);
          }

          var headerList = _this.createHeadersList(headers.headerList, 1);

          columnDefinitions.push.apply(columnDefinitions, __spread(headerList));
        }
      }

      return columnDefinitions;
    };

    _this.onResultsChange = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var results, headers, newHeaderList;

        var _this = this;

        return __generator(this, function (_a) {
          results = this.props.results;
          headers = results && results.headers;

          if (results && results.headers) {
            headers = results.headers;
            newHeaderList = headers.headerList && this.addShowToHeaders(cloneDeep(headers.headerList));
            headers = __assign(__assign({}, headers), {
              headerList: newHeaderList
            });
          }

          this.setState({
            headers: headers
          }, function () {
            return __awaiter(_this, void 0, void 0, function () {
              var columnArray;

              var _this = this;

              return __generator(this, function (_a) {
                columnArray = this.getColumnDefinitions();
                this.setState({
                  columnArray: columnArray
                }, function () {
                  return _this.setRowData();
                });
                return [2
                /*return*/
                ];
              });
            });
          });
          return [2
          /*return*/
          ];
        });
      });
    };

    _this.updateRowDataByCurrency = function (rowData) {
      var _a = _this.state,
          currency = _a.currency,
          priceMode = _a.priceMode;

      if (!currency) {
        return _this.props.results && _this.props.results.rowData && changeRowDataByPriceMode(priceMode, _this.props.results.rowData);
      }

      if (rowData && rowData.length > 0 && currency) {
        rowData = changeRowDataByPriceMode(priceMode, _this.props.results.rowData);
        var selectedCurrency = _this.state.currency.value;
        var currencyRow = rowData.find(function (row) {
          return Object.keys(row).find(function (rowKey) {
            return get(row, rowKey + ".productPrice.currency");
          });
        });

        if (!currencyRow) {
          return rowData;
        }

        var newRowData = cloneDeep(rowData);
        newRowData = updatePriceByBudgetRate(newRowData, _this.budgetRatesMap, selectedCurrency);
        return newRowData;
      }

      return rowData;
    };

    _this.onPriceModeChange = function (event) {
      var priceMode = event.target.value;

      if (priceMode) {
        _this.setState(function (prevState) {
          var rowData = changeRowDataByPriceMode(priceMode, prevState.rowData);
          return {
            rowData: rowData,
            priceMode: priceMode
          };
        });
      }
    };

    _this.setRowData = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var results, rowData, _a, currency, fiscalYear, _b, allConversionNotPossible;

        var _this = this;

        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              results = this.props.results;
              rowData = results ? results.rowData : null;
              if (!rowData) return [3
              /*break*/
              , 3];
              rowData = changeRowDataByPriceMode(this.state.priceMode, rowData);
              _a = this.state, currency = _a.currency, fiscalYear = _a.fiscalYear;
              if (!currency) return [3
              /*break*/
              , 2];
              _b = this;
              return [4
              /*yield*/
              , createBudgetRateMap(rowData, this.state.currency, fiscalYear)];

            case 1:
              _b.budgetRatesMap = _c.sent();
              allConversionNotPossible = this.budgetRatesMap.find(function (value) {
                return !value || value && value.rate === null;
              });

              if (allConversionNotPossible) {
                this.setState({
                  showCurrencySnackbar: currency && currency.value
                });
              }

              rowData = this.updateRowDataByCurrency(rowData);
              _c.label = 2;

            case 2:
              this.setState({
                rowData: rowData
              });
              return [3
              /*break*/
              , 4];

            case 3:
              this.setState({
                rowData: null
              }, function () {
                if (!_this.state.showPriceChart) {
                  if (_this.priceGridApi && _this.state.selectedIndex === 0) {
                    try {
                      _this.priceGridApi.showLoadingOverlay();
                    } catch (e) {// Block to catch edge case when grid is mounted and unmounted in successions
                    }
                  }
                }

                if (!_this.state.showCostChart) {
                  if (_this.costGridApi && _this.state.selectedIndex === 1) {
                    try {
                      _this.costGridApi.showLoadingOverlay();
                    } catch (e) {// Block to catch edge case when grid is mounted and unmounted in successions
                    }
                  }
                }
              });
              setTimeout(function () {
                if (!_this.state.rowData) {
                  _this.setState({
                    rowData: []
                  });
                }
              }, 50000);
              _c.label = 4;

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    _this.togglePopover = function (key) {
      var showPopover = _this.state.showPopover;

      var popover = __assign({}, showPopover);

      popover[key] = !popover[key];
      Object.keys(popover).forEach(function (newKey) {
        if (newKey !== key && popover[newKey]) {
          popover[newKey] = false;
        }
      });

      _this.setState({
        showPopover: popover
      });
    };

    _this.onChangeCurrency = function (selectedCurrency) {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, rowData, fiscalYear, priceMode, results, newRowData, currencyRow, _b, allConversionsNotPossible;

        var _this = this;

        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              _a = this.state, rowData = _a.rowData, fiscalYear = _a.fiscalYear, priceMode = _a.priceMode;
              results = this.props.results;
              if (!(results && results.rowData)) return [3
              /*break*/
              , 2];

              if (!selectedCurrency) {
                newRowData = rowData;

                if (results && results.rowData) {
                  newRowData = changeRowDataByPriceMode(priceMode, this.props.results.rowData);
                }

                return [2
                /*return*/
                , this.setState({
                  currency: undefined,
                  rowData: newRowData
                })];
              }

              currencyRow = rowData.find(function (row) {
                return Object.keys(row).find(function (rowKey) {
                  return get(row, rowKey + ".productPrice.currency");
                });
              });

              if (!currencyRow) {
                return [2
                /*return*/
                , this.setState({
                  currency: selectedCurrency,
                  showCurrencySnackbar: null
                })];
              }

              _b = this;
              return [4
              /*yield*/
              , createBudgetRateMap(results.rowData, selectedCurrency, fiscalYear)];

            case 1:
              _b.budgetRatesMap = _c.sent();
              allConversionsNotPossible = this.budgetRatesMap.find(function (value) {
                return !value || value && value.rate === null;
              });

              if (allConversionsNotPossible) {
                return [2
                /*return*/
                , this.setState({
                  showCurrencySnackbar: selectedCurrency && selectedCurrency.value
                })];
              }

              return [2
              /*return*/
              , this.setState({
                currency: selectedCurrency,
                showCurrencySnackbar: null
              }, function () {
                var newRowData = _this.updateRowDataByCurrency(results.rowData);

                _this.setState({
                  rowData: newRowData
                });
              })];

            case 2:
              return [2
              /*return*/
              , this.setState({
                showCurrencySnackbar: selectedCurrency && selectedCurrency.value
              })];
          }
        });
      });
    };

    _this.closePopover = function (popoverType) {
      var _a;

      var showPopover = _this.state.showPopover;

      _this.setState({
        showPopover: __assign(__assign({}, showPopover), (_a = {}, _a[popoverType] = false, _a))
      });
    };

    _this.hideSnackbar = function () {
      return _this.setState({
        showCurrencySnackbar: false
      });
    };

    _this.updateSelectedTab = function (e, selectedKey) {
      if (_this.props.saveTabInfo) {
        _this.props.saveTabInfo(_this.state.grossMarginSelections, getKeyFromTabIndex(selectedKey));
      }

      _this.props.onSelectedTabChange(selectedKey);

      _this.setState({
        selectedIndex: selectedKey
      });
    };

    _this.getHeadersForTabs = function (headers) {
      if (headers) {
        var pinned = headers.pinned,
            headerList = headers.headerList;
        var headerListPrice_1 = [];
        var headerListCost_1 = [];
        headerList.forEach(function (header) {
          if (['Manufacturing Cost', 'Network'].includes(header.name)) {
            headerListCost_1.push(header);
          } else {
            headerListPrice_1.push(header);
          }
        });
        var headerPrice = {
          pinned: pinned,
          headerList: headerListPrice_1
        };
        var headerCost = {
          pinned: pinned,
          headerList: headerListCost_1
        };

        var colDefPrice = _this.getColumnDefinitionsV2(headerPrice);

        var colDefCost = _this.getColumnDefinitionsV2(headerCost);

        if (colDefCost.length <= 1) _this.costGridApi = undefined;
        if (colDefPrice.length <= 1) _this.priceGridApi = undefined;
        return {
          headerPrice: colDefPrice,
          headerCost: colDefCost,
          grossMarginHeader: {
            headerPrice: headerPrice,
            headerCost: headerCost
          }
        };
      }

      return {
        headerPrice: [],
        headerCost: [],
        grossMarginHeader: {}
      };
    };

    _this.grossMarginSelectionChange = function (selectedItem, type) {
      var _a = _this.state,
          grossMarginSelections = _a.grossMarginSelections,
          selectedIndex = _a.selectedIndex;
      grossMarginSelections[type] = selectedItem;

      _this.setState({
        grossMarginSelections: grossMarginSelections
      }, function () {
        if (_this.props.saveTabInfo) {
          _this.props.saveTabInfo(grossMarginSelections, getKeyFromTabIndex(selectedIndex));
        }
      });
    };

    _this.isDataMissing = function (rowData, gridHeaders) {
      return rowData !== null && rowData.length && gridHeaders && gridHeaders.length <= 1;
    }; // AG-GRID CALLBACKS


    _this.setPinnedHeaderContent = function () {
      if (_this.costGridApi && _this.costGridApi.headerRootComp.ePinnedLeftHeader) {
        var pinnedHeaderName = _this.state.headers && _this.state.headers.pinned ? _this.state.headers.pinned.name : 'Quantity';
        _this.costGridApi.headerRootComp.ePinnedLeftHeader.innerHTML = "<div class='ag-grid-quantity'><span class='quantity-text'>" + capitalize(pinnedHeaderName) + "</span></div>";
      }

      if (_this.priceGridApi && _this.priceGridApi.headerRootComp.ePinnedLeftHeader) {
        var pinnedHeaderName = _this.state.headers && _this.state.headers.pinned ? _this.state.headers.pinned.name : 'Quantity';
        _this.priceGridApi.headerRootComp.ePinnedLeftHeader.innerHTML = "<div class='ag-grid-quantity'><span class='quantity-text'>" + capitalize(pinnedHeaderName) + "</span></div>";
      }
    };

    _this.onCostGridReady = function (params) {
      _this.costGridApi = params.api;

      _this.setPinnedHeaderContent();
    };

    _this.onPriceGridReady = function (params) {
      _this.priceGridApi = params.api;

      _this.setPinnedHeaderContent();
    };

    _this.onCostGridSizeChanged = function (params) {
      _this.costGridApi = params.api;

      _this.setPinnedHeaderContent();
    };

    _this.onPriceGridSizeChanged = function (params) {
      _this.priceGridApi = params.api;

      _this.setPinnedHeaderContent();
    };

    _this.onRowDragLeave = function (event) {
      // TODO: Destructuring rule
      // eslint-disable-next-line prefer-destructuring
      _this.lastRowItem = Object.entries(event.node.data)[0][1];
    };

    _this.onDisplayedColumnsChanged = function (params) {
      params.api.sizeColumnsToFit();

      _this.setPinnedHeaderContent();
    };

    _this.onDragStopped = function (params) {
      var orderedRows = [];
      params.api.sizeColumnsToFit();
      params.api.forEachNode(function (node) {
        return orderedRows.push(Object.entries(node.data)[0][1]);
      });
    }; // GRID ICONS


    _this.chartIcon = function (type, status, disabled) {
      if (disabled === void 0) {
        disabled = false;
      }

      var graphIcon = React.createElement(Button, {
        disabled: disabled,
        key: "graph",
        className: "shippingButton charts-button",
        onClick: function onClick() {
          ingestData({
            feature: 'Charts'
          });
          if (type === 'cost') _this.setState({
            showCostChart: true
          });else if (type === 'price') _this.setState({
            showPriceChart: true
          });else if (type === 'grossMargin') _this.setState({
            showGrossMarginChart: true
          });
        }
      }, React.createElement(Icon, {
        color: colors.teal.base,
        name: "graph-bar-movement-f",
        size: "2x"
      }));
      var gridIcon = React.createElement(Button, {
        className: "shippingButton grid-button",
        key: "grid",
        onClick: function onClick() {
          if (type === 'cost') _this.setState({
            showCostChart: false
          });else if (type === 'price') _this.setState({
            showPriceChart: false
          });else if (type === 'grossMargin') _this.setState({
            showGrossMarginChart: false
          });
        }
      }, React.createElement(Icon, {
        color: colors.teal.base,
        name: "picture-view-all-f",
        size: "2x"
      }));
      var button = !status ? graphIcon : gridIcon;
      return React.createElement("div", {
        className: "panel-icon",
        id: "charts-section"
      }, !disabled ? React.createElement(Tooltip, {
        direction: "top",
        contents: !status ? 'Graphical View' : 'Tabular View'
      }, button) : React.createElement("span", null, button));
    };

    _this.shippingIcon = function (disabled) {
      if (disabled === void 0) {
        disabled = false;
      }

      var content = [React.createElement(Button, {
        disabled: disabled,
        key: "shipping",
        className: "shippingButton shipping-button",
        onClick: function onClick() {
          ingestData({
            feature: 'Shipping'
          });

          _this.setState({
            showShippingModal: true
          });
        }
      }, React.createElement(Icon, {
        color: colors.teal.base,
        size: "2x",
        name: "truck-2-f"
      })), React.createElement("div", {
        key: "shipping-modal"
      }, React.createElement(ConfigShippingContainer, {
        onShippingSubmit: _this.props.onShippingSubmit,
        fulfillmentLocations: convertFulfillmentLocationToOptions(_this.props.fulfillmentLocations),
        deliveryLocations: getDeliveryLocationOptions(_this.props.deliveryLocations),
        shippingConfig: _this.props.shippingConfiguration,
        open: _this.state.showShippingModal,
        closeModal: function closeModal() {
          return _this.setState({
            showShippingModal: false
          });
        },
        productionTime: _this.props.productionTime,
        isSaveShippingEnabled: _this.props.isSaveShippingEnabled,
        saveShippingConfig: _this.props.saveShippingConfig
      }))];
      return React.createElement("div", {
        className: "panel-icon shipping-section",
        id: "shipping-section"
      }, disabled ? content : React.createElement(Tooltip, {
        direction: "top",
        contents: "Shipping Configuration"
      }, content));
    };

    _this.exportIcon = function () {
      return React.createElement("div", {
        className: "panel-icon",
        id: "export-section"
      }, React.createElement(Export, {
        tabbedView: true
      }));
    };

    _this.settingsIcon = function () {
      var _a = _this.state,
          showPopover = _a.showPopover,
          currency = _a.currency,
          currencyOptions = _a.currencyOptions,
          priceMode = _a.priceMode;
      return React.createElement("div", {
        className: "panel-icon",
        style: {
          zIndex: 1
        },
        id: "setting-section"
      }, React.createElement(Tooltip, {
        direction: "top",
        contents: "Settings"
      }, React.createElement(Tooltip, {
        tooltipStyle: tooltipStyle,
        direction: "bottom",
        variety: "popover",
        className: "popover-custom-style settings-tooltip",
        show: showPopover.settings,
        onClickOutside: function onClickOutside() {
          return _this.closePopover('settings');
        },
        contents: React.createElement("form", {
          className: "setting-form"
        }, React.createElement(Tooltip, {
          contents: "If no currency is selected, currency in which actual price/cost is configured will be shown",
          direction: "right"
        }, ' ', React.createElement("h6", null, "Currency")), React.createElement("div", {
          style: {
            width: '165px',
            paddingTop: '5px'
          }
        }, React.createElement(Dropdown, {
          searchable: true,
          placeholder: "Select Currency",
          value: currency,
          options: currencyOptions,
          onChange: _this.onChangeCurrency,
          styles: customStyles,
          isOptionDisabled: function isOptionDisabled(option) {
            return option.disabled;
          },
          isClearable: true,
          className: "currency-select"
        })), React.createElement("hr", null), React.createElement("div", {
          className: "price-type"
        }, React.createElement("h6", null, "Price Settings"), React.createElement(FormControl, {
          component: "fieldset"
        }, React.createElement(RadioGroup, {
          "aria-label": "gender",
          name: "gender1",
          value: priceMode,
          className: "export-form"
        }, React.createElement(FormControlLabel, {
          onClick: _this.onPriceModeChange,
          className: "export-label",
          value: "total",
          control: React.createElement(Radio, null),
          label: "Total Price"
        }), React.createElement(FormControlLabel, {
          onClick: _this.onPriceModeChange,
          className: "export-label",
          value: "unit",
          control: React.createElement(Radio, null),
          label: "Price Per Item"
        })))))
      }, React.createElement("button", {
        type: "button",
        id: "setting-button",
        className: "shippingButton setting-button",
        onClick: function onClick() {
          return _this.togglePopover('settings');
        }
      }, React.createElement(Icon, {
        color: colors.teal.base,
        name: "cog-f",
        size: "2x"
      })))));
    };

    _this.budgetRateErrorSnackBar = function (showCurrencySnackbar) {
      return React.createElement(Snackbar, {
        show: showCurrencySnackbar,
        bsStyle: "danger",
        onHideSnackbar: _this.hideSnackbar
      }, "Error in fetching budget rate for the selected currency " + showCurrencySnackbar);
    };

    _this.pricingGridNoDataLayout = function (message) {
      return React.createElement("div", {
        style: {
          display: 'grid',
          placeItems: 'center',
          minHeight: '200px'
        }
      }, React.createElement(Robot, {
        bsStyle: "warning",
        size: "sm"
      }), message);
    };

    _this.tabContent = function (header, agGridCallbacks, defaultColDef, frameworkComponents, gridType) {
      var _a = _this.state,
          rowData = _a.rowData,
          priceMode = _a.priceMode,
          currency = _a.currency,
          showCurrencySnackbar = _a.showCurrencySnackbar,
          showCostChart = _a.showCostChart,
          showPriceChart = _a.showPriceChart,
          showLoadingSpinnerEquivalency = _a.showLoadingSpinnerEquivalency;
      var _b = _this.props,
          contracts = _b.contracts,
          sellers = _b.sellers,
          showToolBar = _b.showToolBar,
          logger = _b.logger,
          toolBarIcons = _b.toolBarIcons,
          pricingVersion = _b.pricingVersion;
      var onGridReady = agGridCallbacks.onGridReady,
          onGridSizeChanged = agGridCallbacks.onGridSizeChanged;
      var showChart = false;
      if (gridType === 'cost') showChart = showCostChart;else if (gridType === 'price') showChart = showPriceChart;
      return React.createElement("div", {
        className: "ag-theme-balham ag-grid-custom-style ag-no-pivot-style"
      }, gridType === 'cost' && showLoadingSpinnerEquivalency ? React.createElement("div", {
        style: {
          display: 'grid',
          placeItems: 'center',
          marginBottom: '10px'
        }
      }, React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, React.createElement(Spinner, {
        size: "small"
      }), React.createElement("div", {
        style: {
          marginLeft: '5px'
        }
      }, "Loading Equivalencies"))) : null, _this.budgetRateErrorSnackBar(showCurrencySnackbar), rowData !== null && header.length > 1 && showToolBar && React.createElement("div", {
        className: "icon-panel"
      }, React.createElement("div", {
        className: "icon-panel-inner"
      }, toolBarIcons.shipping && _this.shippingIcon(false), toolBarIcons.charts && _this.chartIcon(gridType, showChart), toolBarIcons.export && _this.exportIcon(), toolBarIcons.settings && _this.settingsIcon())), React.createElement("div", {
        className: "pivot-grid"
      }, !showChart ? React.createElement(AgGridReact, {
        columnDefs: rowData && header.length > 1 ? header : [],
        rowData: !rowData || header.length > 1 ? cloneDeep(rowData) : [],
        rowHeight: 45,
        headerHeight: 45,
        groupHeaderHeight: 45,
        enableFilter: true,
        enableSorting: true,
        enableColResize: true,
        gridAutoHeight: true,
        rowDragManaged: true,
        animateRows: true,
        suppressCellSelection: true,
        suppressFieldDotNotation: true,
        defaultColDef: defaultColDef,
        onGridReady: onGridReady,
        onDisplayedColumnsChanged: _this.onDisplayedColumnsChanged,
        suppressDragLeaveHidesColumns: true,
        onDragStopped: _this.onDragStopped,
        onRowDragLeave: _this.onRowDragLeave,
        loadingOverlayComponent: "customLoadingOverlay",
        frameworkComponents: frameworkComponents,
        onGridSizeChanged: onGridSizeChanged
      }) : React.createElement("div", {
        className: "chart-section"
      }, React.createElement("div", {
        className: "chart-section-nested-div"
      }, React.createElement(PricingChart, {
        gridData: rowData,
        headers: header,
        priceMode: priceMode,
        contracts: contracts,
        sellers: sellers,
        currency: currency,
        logger: logger,
        pricingVersion: pricingVersion
      })))));
    };

    _this.state = _this.getInitialState();
    return _this;
  }

  PricingGridLayoutV2.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _this = this;

    var _a = this.state,
        priceMode = _a.priceMode,
        currency = _a.currency;

    if (JSON.stringify(prevProps.results) !== JSON.stringify(this.props.results)) {
      if (this.props.results && this.props.results.headers) {
        if (this.props.showCompetitivePricing) {
          this.createSkuDropdown(this.props.results.headers);
        }

        if (this.props.isPivoting) {
          this.createPivotChildren();
        }
      }

      this.setState({
        rowData: null,
        headers: null
      }, function () {
        return _this.onResultsChange();
      });
    }

    if (JSON.stringify(this.state.headers) !== JSON.stringify(prevState.headers) || JSON.stringify(this.state.skuDropdown) !== JSON.stringify(prevState.skuDropdown)) {
      var _b = this.getHeadersForTabs(cloneDeep(this.state.headers)),
          headerPrice = _b.headerPrice,
          headerCost = _b.headerCost,
          grossMarginHeader = _b.grossMarginHeader;

      var columnArray = this.getColumnDefinitions(); // eslint-disable-next-line react/no-did-update-set-state

      this.setState({
        headerPrice: headerPrice,
        headerCost: headerCost,
        grossMarginHeader: grossMarginHeader,
        columnArray: columnArray
      });
    }

    if (this.props.grossMarginSelections && JSON.stringify(this.props.grossMarginSelections) !== JSON.stringify(prevProps.grossMarginSelections)) {
      // eslint-disable-next-line prefer-destructuring,prefer-const
      var grossMarginSelections = this.props.grossMarginSelections;
      this.setState({
        grossMarginSelections: grossMarginSelections
      });
    }

    if (prevState.currency !== currency || prevState.priceMode !== priceMode && priceMode) {
      var settings = {
        currency: currency && currency.value ? currency.value : undefined,
        priceMode: priceMode
      };
      setGridSettingsUser(settings);
    }

    if (prevProps.isLoadingEquivalencies !== this.props.isLoadingEquivalencies) {
      this.setState({
        showLoadingSpinnerEquivalency: this.props.isLoadingEquivalencies
      });
    }
  };

  PricingGridLayoutV2.prototype.render = function () {
    var _a = this.state,
        headerPrice = _a.headerPrice,
        headerCost = _a.headerCost,
        showCurrencySnackbar = _a.showCurrencySnackbar,
        rowData = _a.rowData,
        priceMode = _a.priceMode,
        currency = _a.currency;
    var _b = this.props,
        showToolBar = _b.showToolBar,
        toolBarIcons = _b.toolBarIcons,
        dualPivotMode = _b.dualPivotMode,
        sellers = _b.sellers,
        logger = _b.logger,
        contracts = _b.contracts;
    var defaultColDef = {
      cellClass: 'defaultCellStyle',
      editable: false,
      lockPinned: true,
      resizable: true
    };
    var frameworkComponents = {
      customLoadingOverlay: CustomLoadingOverlay
    }; // PRICING GRID TABS DEFINITION

    var costView = React.createElement("div", {
      className: "grid-wrapper-style",
      id: "grid-wrapper"
    }, React.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
      }
    }, this.isDataMissing(rowData, headerCost) && !this.state.showLoadingSpinnerEquivalency ? this.pricingGridNoDataLayout('No Cost available for the selected product') : this.tabContent(headerCost, {
      onGridReady: this.onCostGridReady,
      onGridSizeChanged: this.onCostGridSizeChanged
    }, defaultColDef, frameworkComponents, 'cost')));
    var priceView = React.createElement("div", {
      className: "grid-wrapper-style",
      id: "grid-wrapper"
    }, React.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
      }
    }, this.isDataMissing(rowData, headerPrice) ? this.pricingGridNoDataLayout('No price available for the selected product') : this.tabContent(headerPrice, {
      onGridReady: this.onPriceGridReady,
      onGridSizeChanged: this.onPriceGridSizeChanged
    }, defaultColDef, frameworkComponents, 'price')));
    var grossMargin = React.createElement("div", null, rowData && (headerCost && headerCost.length <= 1 || headerPrice && headerPrice.length <= 1) ? this.pricingGridNoDataLayout('Both Cost and Price are required to calculate margin.') : dualPivotMode ? this.pricingGridNoDataLayout('Switch to single pivot mode to calculate margin.') : React.createElement("div", null, this.budgetRateErrorSnackBar(showCurrencySnackbar), showToolBar && rowData !== null && headerCost.length > 1 && headerPrice.length > 1 && React.createElement("div", {
      className: "icon-panel"
    }, React.createElement("div", {
      className: "icon-panel-inner"
    }, toolBarIcons.shipping && this.shippingIcon(true), toolBarIcons.charts && this.chartIcon('grossMargin', this.state.showGrossMarginChart, false), toolBarIcons.export && this.exportIcon(), toolBarIcons.settings && this.settingsIcon())), React.createElement(GrossMarginLayout, {
      results: {
        rowData: rowData,
        headers: this.state.grossMarginHeader
      },
      grossMarginSelections: this.state.grossMarginSelections,
      grossMarginSelectionChange: this.grossMarginSelectionChange,
      showGrossMarginChart: this.state.showGrossMarginChart,
      currency: currency,
      sellers: sellers,
      contracts: contracts,
      priceMode: priceMode,
      logger: logger
    })));
    var tabs = [{
      name: 'Price',
      block: priceView
    }, {
      name: 'Cost',
      block: costView
    }, {
      name: 'Gross Margin',
      block: grossMargin
    }];
    return React.createElement("div", {
      className: "row pivot-parent-rows"
    }, React.createElement(TabCard, {
      tabs: tabs,
      selectedIndex: this.state.selectedIndex,
      onSelect: this.updateSelectedTab
    }));
  };

  PricingGridLayoutV2.defaultProps = {
    priceMode: 'total',
    showToolBar: true,
    toolBarIcons: {
      filter: true,
      shipping: false,
      settings: true,
      export: false,
      charts: false
    }
  };
  PricingGridLayoutV2 = __decorate([withStyles(styles)], PricingGridLayoutV2);
  return PricingGridLayoutV2;
}(Component);

export default PricingGridLayoutV2;